import Button from '@mui/material/Button';

interface RequestQuoteButtonProps {
	url: string;
	buttonText: string;
}

export default function RequestQuoteButton({ url, buttonText }: RequestQuoteButtonProps) {
	return (
		<Button variant="outlined" fullWidth href={url} target="_blank" data-testid="request-quote-button">
			{buttonText}
		</Button>
	);
}
